// extracted by mini-css-extract-plugin
export default {"passwordRequirements":"styles_passwordRequirements__wQg4Y","btnWrapper":"styles_btnWrapper__42IeB"};